export default "__VITE_ASSET__DYqDXwxi__"